import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/ui-bits";
import { roleHome } from "@/lib/constants";

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen grid place-items-center">
        <Spinner className="text-primary w-8 h-8" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={roleHome(user)} replace />;
  return children;
}

// Expert workspace gate: block un-approved experts (pending / rejected) from the
// working areas of the app until a COMPENI admin verifies them.
export function ExpertGate({ children }) {
  const { user } = useAuth();
  if (user?.role === "expert" && user?.expert_status && user.expert_status !== "approved") {
    return <Navigate to="/expert/pending" replace />;
  }
  return children;
}
